export default __webpack_public_path__ + "static/media/logo-white.2bbb2b23.svg";